import React from 'react'

import Heading from 'Design/components/Heading'

const PageHeading = ({ children }) => {
  return <Heading level={1}>{children}</Heading>
}

export default PageHeading
